import styled, { css } from 'styled-components';
import { memo } from 'react';
import { media } from 'utils/media-query-helper';

export const Col = memo(styled.div`
  ${props => {
    const getWidth = size => {
      const marginLeft = props.marginLeft ? +props.marginLeft : 0;
      const marginRight = props.marginRight ? +props.marginRight : 0;
      const margins = props.margin || marginLeft + marginRight;
      if (size) {
        return `calc(${size}% - ${margins}px)`;
      }
    };
    return css`
      flex-grow: ${() => (props.grow ? '1' : 'initial')};
      max-width: 100%;
      width: ${() => getWidth(props.xs)};
      ${media.tablet`
      width: ${() => {
        if (props.sm) {
          return getWidth(props.sm);
        }
      }};
      `};
      ${media.desktop`
      width: ${() => {
        if (props.md) {
          return getWidth(props.md);
        }
      }};
      `};
      ${media.wideScreen`
      width: ${() => {
        if (props.lg) {
          return getWidth(props.lg);
        }
      }};
      `};
      ${media.extraWideScreen`
      width: ${() => {
        if (props.xl) {
          return getWidth(props.xl);
        }
      }};
      `};
    `;
  }};
  padding: ${props => {
    if (props.noPadding) {
      return 0;
    } else if (props.noPaddingLeft) {
      return '0 5px 0 0';
    } else if (props.noPaddingRight) {
      return '0 0 0 5px';
    }
    return '0 5px';
  }};
  margin: ${props =>
    `${props.marginTop || 0}px ${props.marginRight || props.margin || 0}px ${
      props.marginBottom || 0
    }px ${props.marginLeft || props.margin || 0}px`};
`);
